import {ClientSettingsSectionContainerBox} from "./boxes/client-settings-section-container/client-settings-section-container.box"
import {ClientSettingsContentComponent} from "./client-settings-content.component"
import {Button} from "../../../../basic-ui-components/button/base/button.component"
import {useServices} from "../../../../react-hooks/use-services.hook"
import {ClientSettingsTitleBox} from "./boxes/title/client-settings-title.box"
import {ClientSettingsTitleWrapperBox} from "./boxes/title-wrapper/client-settings-title-wrapper.box"

export const ClientSettingsComponent = () => {
    const services = useServices();

    const closeClientSettings = () => {
        services.clientSettings.closeClientSettings();
    }


    return (
        <ClientSettingsSectionContainerBox>
            <ClientSettingsTitleWrapperBox>
                <Button
                    preset="info"
                    stroke="none"
                    icon={{Component: services.theme.currentTheme.icons.closeIcon}}
                    onClick={closeClientSettings}
                    className="close-client-settings-icon"
                />
                <ClientSettingsTitleBox>{services.translation.translate('SETTINGS')}</ClientSettingsTitleBox>
            </ClientSettingsTitleWrapperBox>

            <ClientSettingsContentComponent />
        </ClientSettingsSectionContainerBox>
    )
}